// extracted by mini-css-extract-plugin
export default {"container":"BaseCalendar_container__sOU9X","allDayText":"BaseCalendar_allDayText__-tB8c","slotLabelText":"BaseCalendar_slotLabelText__xztL-"};